<div *ngIf="!isMobile" class="card p-3 mb-3"
     [ngStyle]="{ 'border-radius': hasOrderBeenPlaced ? '0px 0px 5px 5px' : '0.428rem' }">
  <div class="d-flex justify-content-between">
    <div>
      <div class="d-flex">
        <h4 class="mr-1 font-weight-bolder">
          <a
            [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + benefit.providerId + '/' + benefit.benefitId]"
            class="text-decoration-none text-dark">
            {{ benefit.benefitName }}
          </a>
        </h4>
        <app-benefit-history-status
          [benefitHistoryType]="benefit.benefitHistoryType"
          [isAutoOrderEnabled]="benefit.isAutoOrderEnabled"
          [orderStatus]="benefit.orderStatus"
          [orderStatusLabel]="benefit.orderStatusLabel"
          [subscriptionStatus]="benefit.subscriptionStatus"
          [subscriptionStatusLabel]="benefit.subscriptionStatusLabel"
        ></app-benefit-history-status>
      </div>
      <div class="text-dark">{{ benefit?.providerName }}</div>
    </div>

    <div>
      <h4 class="font-weight-bolder text-right" *ngIf="!isInsuranceBenefit()">
        {{
          benefit?.price | number: '1.2-2'
        }} {{ benefit.benefitHistoryType === BenefitHistoryType.AutoOrder ? ('DETAILS.UNIT3' | translate) : ('DETAILS.UNIT1' | translate) }}
      </h4>
      <app-benefit-history-info class="text-right" [benefit]="benefit"></app-benefit-history-info>
    </div>
  </div>

  <hr/>

  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center flex-grow-1">
      <div class="mr-1 flex-shrink-0">
        <img [src]="benefit?.pictureUrl" alt="" class="img-fluid rounded" style="max-height: 80px; width: auto"/>
      </div>
      <div>
        <div class="text-dark small" style="margin-bottom: 2px;">
          {{ 'HISTORY.BENEFIT.NUMBER' | translate }}{{ benefit?.itemId }}
        </div>
        <div class="text-dark small" style="margin-bottom: 2px;">{{ benefit?.createdOn | localizedDate }}</div>
        <div class="text-dark small" style="margin-bottom: 2px;">
          {{ 'HISTORY.BENEFIT.BENEFIT_TYPE' | translate }}
          <span class="font-weight-bold">{{ benefit?.benefitTypeLabel | translate }}</span>
        </div>
        <div class="text-dark small">
          {{ 'HISTORY.BENEFIT.SHIPPING_TYPE' | translate }}
          <span class="font-weight-bold">{{ benefit?.shippingTypeLabel | translate }}</span>
        </div>
      </div>
    </div>

    <div class="align-self-end">
      <a *ngIf="benefit.benefitHistoryType === BenefitHistoryType.Order" class="btn btn-primary"
         [routerLink]="['/' + subdomain + '/benefit-details/order/' + benefit.itemId]">
        {{ 'HISTORY.DETAILS_BUTTON' | translate }}
      </a>
      <a *ngIf="benefit.benefitHistoryType === BenefitHistoryType.Subscription" class="btn btn-primary"
         [routerLink]="['/' + subdomain + '/benefit-details/subscription/' + benefit.itemId]">
        {{ 'HISTORY.DETAILS_BUTTON' | translate }}
      </a>
      <a *ngIf="benefit.benefitHistoryType === BenefitHistoryType.AutoOrder" class="btn btn-primary"
         [routerLink]="['/' + subdomain + '/benefit-details/auto-order/' + benefit.itemId]">
        {{ 'HISTORY.DETAILS_BUTTON' | translate }}
      </a>
    </div>
  </div>
</div>

<div
  *ngIf="isMobile"
  class="card p-1 mb-3"
  [ngStyle]="{ 'border-radius': hasOrderBeenPlaced ? '0px 0px 5px 5px' : '0.428rem' }"
>
  <div class="d-flex justify-content-between">
    <div>
      <div class="d-flex">
        <h4 class="font-weight-bolder">
          <a
            [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + benefit.providerId + '/' + benefit.benefitId]"
            class="text-decoration-none text-dark">
            {{ benefit?.benefitName }}
          </a>
        </h4>
      </div>
      <div class="text-dark">{{ benefit?.providerName }}</div>
      <app-benefit-history-info [benefit]="benefit"></app-benefit-history-info>
    </div>

    <div>
      <h4 class="font-weight-bolder text-right" *ngIf="!isInsuranceBenefit()">
        {{
          benefit?.price | number: '1.2-2'
        }}{{ benefit.benefitHistoryType === BenefitHistoryType.AutoOrder ? ('DETAILS.UNIT3' | translate) : '' }}
      </h4>
      <app-benefit-history-status
        [benefitHistoryType]="benefit.benefitHistoryType"
        [isAutoOrderEnabled]="benefit.isAutoOrderEnabled"
        [orderStatus]="benefit.orderStatus"
        [orderStatusLabel]="benefit.orderStatusLabel"
        [subscriptionStatus]="benefit.subscriptionStatus"
        [subscriptionStatusLabel]="benefit.subscriptionStatusLabel"
        [alignRight]="true"
      ></app-benefit-history-status>
    </div>
  </div>

  <hr/>

  <div class="d-flex justify-content-between align-items-start mb-2">
    <div style="flex-shrink: 0; max-width: 100px; max-height: 100px;">
      <img
        [src]="benefit?.pictureUrl"
        alt=""
        class="img-fluid rounded"
        style="width: 100%; height: 100%; object-fit: cover;"
      />
    </div>
    <div class="flex-shrink-0 ml-2">
      <a *ngIf="benefit.benefitHistoryType === BenefitHistoryType.Order"
         class="btn btn-primary btn-sm"
         [routerLink]="['/' + subdomain + '/benefit-details/order/' + benefit.itemId]"
      >
        {{ 'HISTORY.DETAILS_BUTTON' | translate }}
      </a>
      <a *ngIf="benefit.benefitHistoryType === BenefitHistoryType.Subscription"
         class="btn btn-primary btn-sm"
         [routerLink]="['/' + subdomain + '/benefit-details/subscription/' + benefit.itemId]">
        {{ 'HISTORY.DETAILS_BUTTON' | translate }}
      </a>
      <a *ngIf="benefit.benefitHistoryType === BenefitHistoryType.AutoOrder"
         class="btn btn-primary btn-sm"
         [routerLink]="['/' + subdomain + '/benefit-details/auto-order/' + benefit.itemId]">
        {{ 'HISTORY.DETAILS_BUTTON' | translate }}
      </a>
    </div>
  </div>

  <div class="text-dark small mb-1">
    {{ 'HISTORY.BENEFIT.NUMBER' | translate }}{{ benefit.itemId }}
  </div>
  <div class="text-dark small mb-1">{{ benefit?.createdOn | localizedDate }}</div>
  <div class="text-dark small mb-1">
    {{ 'HISTORY.BENEFIT.BENEFIT_TYPE' | translate }}
    <span class="font-weight-bold">{{ benefit?.benefitTypeLabel | translate }}</span>
  </div>
  <div class="text-dark small">
    {{ 'HISTORY.BENEFIT.SHIPPING_TYPE' | translate }}
    <span class="font-weight-bold">{{ benefit?.shippingTypeLabel | translate }}</span>
  </div>
</div>
